import { useUser } from "@/contexts/user";
import { canAccessAllOrgsAndDevices } from "@/utils/user-permission";

/**
 * A hook to determine if the user is a staff member.
 *
 * @returns A boolean indicating whether the user is a staff member.
 */
const useIsStaff = (): boolean => {
    const { user } = useUser();
    const isStaff = canAccessAllOrgsAndDevices(user);
    return isStaff;
};

export { useIsStaff };
